import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.onScroll();
    }

    intro() {}

    onScroll() {
        const revealElm = [...document.querySelectorAll(".js-scrollreveal")];

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 70%",
                onEnter: (self) => {
                    el.classList.add("-reveal");
                },
                //markers: true,
            });
        });
    }
}
